import { OtsComponentFull } from '@luminovo/http-client';

export function findRawSpecsNotLinked({ component }: { component: OtsComponentFull }) {
    return component.part_specifications.filter(
        (spec) =>
            (!!spec.description || !!spec.manufacturer || !!spec.mpn) &&
            !component.matches.some((part) => part.matching_reason.reason?.id === spec.id),
    );
}
